// extracted by mini-css-extract-plugin
module.exports = {"profile__addresses":"_1OJOCS7F","margin-top":"_5eu1VlwN","marginTop":"_5eu1VlwN","profile-nav__list-item":"_2CS34G66","profileNav__listItem":"_2CS34G66"};